import { makeStyles } from '@material-ui/core/styles';

export const useSnackbarStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.success.light,
    borderLeft: `${theme.spacing(1)}px solid ${theme.palette.success.main}`,
    color: theme.palette.success.contrastText
  }
}));
